/**
 * 国内 港澳台 国际的产品列表
 * (国际或港澳台)的重量上限需要接口返回
 * 台湾的水陆路 航空不支持保价
 */
// 国内的可售卖产品列表
export const productListLand = [{
  name: '即日',
  productCode: '111114300000191',
  productName: '即日专递',
  productType: 10,
  isPickupAvailable: true, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 50, // 最大保价声明，单位为万元
  safeguardFeeRate: 0.005, // 保费根据声明价值转换倍率
  goodsTypes: ['1', '2'], // 1：文件，2:物品
  maxWeight: 40, // 重量上限
  maxVolumeLength: 150, // 单边上限
  maxVolumeTotal: 300, // 三边和上限
  volumeOverSizeTip: '不支持长+宽*2+高*2合计超过300cm的物品收寄', // 超体积规格提示语
  realFee: '',
  totalFee: '',
  receiveTime: ''
}, {
  name: '特快',
  productCode: '112104302300991',
  productName: '特快专递',
  productType: 7,
  isPickupAvailable: true, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 50, // 最大保价声明，单位为万元
  safeguardFeeRate: 0.005, // 保费根据声明价值转换倍率
  goodsTypes: ['1', '2'], // 1：文件，2:物品
  maxWeight: 40, // 重量上限
  maxVolumeLength: 150, // 单边上限
  maxVolumeTotal: 300, // 三边和上限
  volumeOverSizeTip: '不支持长+宽*2+高*2合计超过300cm的物品收寄', // 超体积规格提示语
  realFee: '',
  totalFee: '',
  receiveTime: ''
}, {
  name: '标快',
  productCode: '116104300000991',
  productName: '标准快递',
  productType: 11,
  isPickupAvailable: true, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 5, // 最大保价声明，单位为万元
  safeguardFeeRate: 0.005, // 保费根据声明价值转换倍率
  goodsTypes: ['1', '2'], // 1：文件，2:物品
  maxWeight: 30, // 重量上限
  maxVolumeLength: 100, // 单边上限
  maxVolumeTotal: 250, // 三边和上限
  volumeOverSizeTip: '不支持长+宽*2+高*2合计超过250cm的物品收寄', // 超体积规格提示语
  realFee: '',
  totalFee: '',
  receiveTime: ''
}, {
  name: '快递包裹',
  productCode: '113124300000691',
  productName: '快递包裹',
  productType: 8,
  isPickupAvailable: false, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 3, // 最大保价声明，单位为万元
  safeguardFeeRate: 0.01, // 保费根据声明价值转换倍率
  goodsTypes: ['1', '2'], // 1：文件，2:物品
  maxWeight: 20, // 重量上限
  maxVolumeLength: 100, // 单边上限
  maxVolumeTotal: 300, // 三边和上限
  volumeOverSizeTip: '不支持长宽高合计超过300cm的物品收寄', // 超体积规格提示语
  realFee: '',
  totalFee: '',
  receiveTime: ''
}]

// 港澳台的可售卖产品列表
export const productListSar = [{
  name: '港澳台特快专递',
  productCode: '212105100000991',
  productName: '港澳台特快专递',
  isPickupAvailable: true, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 2, // 最大保价声明，单位为万元
  goodsTypes: ['1', '2'], // 1：文件，2:物品
  maxWeight: 40, // 重量上限
  maxVolumeLength: 150, // 单边上限
  realFee: '',
  totalFee: '',
  receiveTime: ''
}, {
  name: '港澳台航空包裹',
  productCode: '214125309100791',
  productName: '港澳台航空包裹',
  isPickupAvailable: false, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 1, // 最大保价声明，单位为万元
  goodsTypes: ['2'], // 1：文件，2:物品
  maxWeight: 40, // 重量上限
  maxVolumeLength: 150, // 单边上限
  realFee: '',
  totalFee: '',
  receiveTime: ''
}, {
  name: '港澳台水陆路包裹',
  productCode: '214125308900791',
  productName: '港澳台水陆路包裹',
  isPickupAvailable: false, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 1, // 最大保价声明，单位为万元
  goodsTypes: ['2'], // 1：文件，2:物品
  maxWeight: 40, // 重量上限
  maxVolumeLength: 150, // 单边上限
  realFee: '',
  totalFee: '',
  receiveTime: ''
}]

// 国际的可售卖产品列表
export const productListInt = [{
  name: '国际特快专递',
  productCode: '212105100000991',
  productName: '国际特快专递',
  isPickupAvailable: true, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 2, // 最大保价声明，单位为万元
  goodsTypes: ['1', '2'], // 1：文件，2:物品
  maxWeight: 40, // 重量上限
  maxVolumeLength: 150, // 单边上限
  realFee: '',
  totalFee: '',
  receiveTime: ''
}, {
  name: '国际水陆路包裹',
  productCode: '214125309000791',
  productName: '国际水陆路包裹',
  isPickupAvailable: false, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 1, // 最大保价声明，单位为万元
  goodsTypes: ['2'], // 1：文件，2:物品
  maxWeight: 40, // 重量上限
  maxVolumeLength: 150, // 单边上限
  realFee: '',
  totalFee: '',
  receiveTime: ''
}, {
  name: '国际航空包裹',
  productCode: '214125309200791',
  productName: '国际航空包裹',
  isPickupAvailable: false, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 1, // 最大保价声明，单位为万元
  goodsTypes: ['2'], // 1：文件，2:物品
  maxWeight: 40, // 重量上限
  maxVolumeLength: 150, // 单边上限
  realFee: '',
  totalFee: '',
  receiveTime: ''
}, {
  name: '国际空运水陆路包裹',
  productCode: '214125309800791',
  productName: '国际空运水陆路包裹',
  isPickupAvailable: false, // 是否支持上门派揽
  isCanInsured: true, // 是否允许保价
  maxSafeguardCost: 1, // 最大保价声明，单位为万元
  goodsTypes: ['2'], // 1：文件，2:物品
  maxWeight: 40, // 重量上限
  maxVolumeLength: 150, // 单边上限
  realFee: '',
  totalFee: '',
  receiveTime: ''
}]
